import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Publish } from "@mui/icons-material";
import { ImageUploader } from "../../assignment/routes/DirectStudentAnswerUploader";
import { useSearchParams } from "react-router-dom";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";

const TemporaryImageUpload = () => {
  const [images, setImages] = useState([]);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const ApiClient = useApiClient();

  const submitImages = async () => {
    try {
      const response = await ApiClient.core.uploadTempImages({
        token,
        images,
      });

      if (response.success) {
        enqueueSnackbar("Successfully submitted, submit another?", {
          variant: "success",
          autoHideDuration: 3000,
        });
        setImages([]);
      } else {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error submitting, please try again", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <FruitifyContainer>
      <ImageUploader
        title={"Take picture of the student's answer"}
        images={images}
        setImages={setImages}
        identifierSelector={null}
      />

      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          disabled={images.length === 0}
          variant={"outlined"}
          endIcon={<Publish />}
          fullWidth
          onClick={submitImages}
        >
          Submit
        </Button>
      </Box>
    </FruitifyContainer>
  );
};

export default TemporaryImageUpload;
